var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./Faq.less');

var FaqContent = require('front/components/FaqContent/FaqContent');


module.exports = Section.extend({

    el: '.Faq',


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'FaqContent': {selector: '.FaqContent', viewConstructor: FaqContent}
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Faq/Faq.js
// module id = 262
// module chunks = 0